<div class="wrapper">
    <div class="content-wrapper">
        <div class="container-fluid p-0">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>